import styled from "@emotion/styled";

export const MDSSessionPartContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing["1"]};
`;
